import { PersonaInfoSummary } from '../../../../therapist/pages/tasks/types/Task'
import { axios, Response } from '..'
import { UserInfo } from '../feed/get-post-by-id'
import { GetTaskTagsResponse } from './get-all-task-tags'

export interface GetTasksResponse {
  id: string
  title: string
  description?: string
  startDate?: string
  endDate?: string
  taskStatus: string
  files?: SaveFileRequest[]

  /* Member IDs.*/
  personaInfoSummaries?: UserInfo[]
  taskTags?: GetTaskTagsResponse[]
  checklists?: ChecklistRequest[]
  taskComments?: GetTaskCommentResponse[]

  /* Only for post with tasks */
  isAssigned?: boolean
}

interface SaveFileRequest {
  fileName: string
  fileContentType: string
}

interface ChecklistRequest {
  id: string
  title: string
  taskId?: string
  checklistItems?: ChecklistItemRequest[]
}

interface ChecklistItemRequest {
  id: string
  title: string
  checklistId?: string
  responsibleForTheDemandId?: PersonaInfoSummary
  isDone?: boolean
}

export interface GetTaskCommentResponse {
  taskCommentId: string
  taskId: string
  content: string
  creator: UserInfo
  createdAt: string
}

/* Not used in anywhere */

export const getTaskByMemberId = (
  taskId: string
): Response<GetTasksResponse> => {
  return axios.get(`/v1/task/${taskId}`, {})
}
